import { render } from "./LbrxTicketOnHold.vue?vue&type=template&id=2516da50&scoped=true"
import script from "./LbrxTicketOnHold.vue?vue&type=script&lang=js"
export * from "./LbrxTicketOnHold.vue?vue&type=script&lang=js"

import "./LbrxTicketOnHold.vue?vue&type=style&index=0&id=2516da50&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2516da50"]])

export default __exports__